import { useEffect, useState } from "react";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle.jsx";
import { getAllStudents } from "../../../helpers/getAllStudents.js";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled.jsx";
import * as styled from "./AllStudents.styled.jsx";
import Loader from "../../../components/Loader/Loader.jsx";
import { useNavigate } from "react-router-dom";

function AllStudents() {
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    getAllStudents().then((students) => {
      const filtered = students.filter(
        ({ isTest }) => !isTest
      );
      setStudents(filtered);
    });
  }, []);
  useEffect(() => {
    const searchTerm = search.toLowerCase();
    setFilteredStudents(
      students.filter(
        ({ name, studentId }) =>
          name.toLowerCase().includes(searchTerm) ||
          studentId.toLowerCase().includes(searchTerm)
      )
    );
  }, [search, students]);

  if (students.length === 0) return <Loader />;
  return (
    <PagesWrapper>
      <TopPageTitle value="Усі учні" />
      <styled.TopWrapper>
        <styled.TotalStudents>{students.length} students</styled.TotalStudents>
        <styled.SearchInput
          placeholder="Пошук за ім'ям або ID..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </styled.TopWrapper>
      <styled.List>
        <styled.AddStudentItem onClick={() => navigate(`/admin/ourstudents/all/addstudent`)}>
          <styled.ItemTitle>+ Додати учня</styled.ItemTitle>
        </styled.AddStudentItem>
        {filteredStudents.map(({ _id, studentId, name, ageGroup }) => (
          <styled.Item
            key={_id}
            onClick={() => navigate(`/admin/ourstudents/${ageGroup}/${_id}`)}
          >
            <styled.ItemTitle>{`${name} - id(${studentId})`}</styled.ItemTitle>
          </styled.Item>
        ))}
      </styled.List>
    </PagesWrapper>
  );
}

export default AllStudents;
